import { IProcessFlowVariable } from '~/interfaces/processFlowInterfaces'
import ProcessFlow from "~/models/processFlows/processFlow"
import ProcessFlowStep from "~/models/processFlows/processFlowStep"
import ProcessFlowVariable from '~/models/processFlows/processFlowVariable'
import IterationStep from "~/models/processFlows/steps/iterationStep"
import { ProcessFlowStepType } from "../../../enums/processFlowStepType"

export class ProcessFlowExportCSVStep extends ProcessFlowStep {
  step_type: ProcessFlowStepType.ExportCSV
  input_variable_client_id: string
  destination_variable_client_id: string
  file_name: string

  constructor(parent: ProcessFlow | IterationStep, options?) {
    super(parent, options)
    this.defineProperty('input_variable_client_id', null)
    this.defineProperty('destination_variable_client_id', null);
    this.defineProperty('file_name', '');

    if (options.firstCreation) {
      // do not setup defaults when loading json from backend
    }
  }

  get defaultTitle(): string {
    return `Export CSV Step`
  }

  get inputVariable(): IProcessFlowVariable {
    return ProcessFlowVariable.repo.find(this.input_variable_client_id);
  }

  get destinationVariable(): IProcessFlowVariable {
    return ProcessFlowVariable.repo.find(this.destination_variable_client_id);
  }

  get destinationVariableClientId(): string {
    return this.destination_variable_client_id
  }

  set destinationVariableClientId(val: string) {
    this.destination_variable_client_id = val
  }

  private get outputVariable(): IProcessFlowVariable {
    return ProcessFlowVariable.repo.find(this.destinationVariableClientId)
  }
}